import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  CreateMarketingCampaignPayload,
  MarketingCampaign
} from "../../marketing.types";
import { requestCreateMarketingCampaign } from "./createMarketingCampaign.request";

const useCreateMarketingCampaign = (
  options?: MutationOptions<
    MarketingCampaign,
    ApiServiceError<ApiError>,
    CreateMarketingCampaignPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestCreateMarketingCampaign,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["marketing", "campaigns"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useCreateMarketingCampaign;
